import React from "react";
import PageSkeleton from "./PageSkeleton";

const Loading: React.FC<{
  compact?: boolean;
  variant?: "table" | "cards" | "dashboard";
}> = ({ compact, variant }) => (
  <PageSkeleton compact={compact} variant={variant} />
);
export default Loading;
